'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = ActivityListItemSecondaryAction;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ActivityListItemSecondaryAction', function (theme) {
  return {
    root: _defineProperty({
      flex: '1 0 auto',
      textAlign: 'left',
      padding: 0,
      minWidth: theme.typography.rhythmByUnit(11)
    }, theme.breakpoints.up('sm'), {
      textAlign: 'right'
    })
  };
});

function ActivityListItemSecondaryAction(props, context) {
  var className = props.className,
      children = props.children,
      other = _objectWithoutProperties(props, ['className', 'children']);

  var classes = context.styleManager.render(styleSheet);

  return _react2['default'].createElement(
    'div',
    _extends({ className: (0, _classnames2['default'])(classes.root, className) }, other),
    children
  );
}

ActivityListItemSecondaryAction.displayName = 'ActivityListItemSecondaryAction';

ActivityListItemSecondaryAction.contextTypes = {
  styleManager: _PropTypes2['default'].object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/ActivityListItemSecondaryAction.js
// module id = 730
// module chunks = 32